import React from 'react';
import {inlBlockStyle} from "./ColorSchemes.jsx";

class BreadCrumb extends React.Component {
   
   constructor(props)
   {
      super(props);
   }
	
   render() {
      //console.log("nr of crumbs: " + this.props.crumbs.length);
      var horizontalBarStyle =
      {
         //listStyle:'none',
         //verticalAlign:'top',
         //background: colorSchemes.btn[this.props.depth],
         display: 'block',
         padding: 0,
         margin: 0,
         height: 40,
      }


      var spacerStyle =
      {
         display: 'inline-block',
         height: '100%',
         width: 30,
      }

      var noClickCrumbStyle =
      {
         display:'inline-block',
         padding: 10,
      }


      var crumbStyle = {
         //float: 'right',
         //height: 40,
         display: 'inline-block',
         padding: 10,
         //background: this.props.isCurrent ? this.activeColor : this.inactiveColor,
         listStyle: 'none',
          cursor: 'pointer',
          textDecoration: 'underline',
         //width:'100%',
      }
      var crumbCount = this.props.crumbs.length;
      return (
         <div style={horizontalBarStyle}>
         <div style = {noClickCrumbStyle}>You are here:</div>
            
            {this.props.crumbs.map((crumb, i) => 
               <BreadCrumbElem key = {i} data = {crumb} isLast = {i == crumbCount -1}
               cB = {this.props.clickedCrumb} depth = {i} elemStyle = {i == crumbCount -1 ? noClickCrumbStyle : crumbStyle}/> )}

         </div>
      );
   }
}

export default BreadCrumb;

class BreadCrumbElem extends React.Component
{
  constructor(props)
  {
      super(props);

      this.cB = function(e)
      {
         this.props.cB(this.props.depth);
      }.bind(this);
  }
   render() {

      var spacerStyle =
      {
         display: 'inline-block',
         height: '100%',
         //backgroundImage: 'url(./Assets/ico-black-arrow.png)',
         backgroundSize: 'contain',
      }

      return (
            <div style = {inlBlockStyle}>
               <div style={this.props.elemStyle} onClick = {this.cB}>{this.props.data.name}</div>
               {this.props.isLast ? null :
                     <div style = {spacerStyle}>-></div> }
            </div>

      );
   }
}



// WEBPACK FOOTER //
// ./js/BreadCrumb.jsx